import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { COMPANY_INFO } from '../../data/siteData';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-navy text-white border-t border-white/10">
      <div className="max-w-container mx-auto px-4 sm:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          {/* Brand Column */}
          <div className="md:col-span-5 space-y-4">
            <Link to="/" className="inline-block">
              <img
                src="/assets/spaq-logo.png"
                alt="Spaq株式会社"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-slate-300 leading-relaxed max-w-md">
              電気を、もっと賢く、無駄なく。<br />
              設計から制御まで、電力インテリジェンスを社会へ。
            </p>
            <div className="pt-2 space-y-1.5 text-xs text-slate-300">
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-spaq-cyan-bright shrink-0 mt-0.5" />
                <span>{COMPANY_INFO.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-spaq-cyan-bright shrink-0" />
                <span>TEL：{COMPANY_INFO.tel}（{COMPANY_INFO.hours}）</span>
              </div>
            </div>
          </div>

          {/* Navigation Columns */}
          <div className="md:col-span-3 space-y-3">
            <div className="text-xs font-bold tracking-wider uppercase text-spaq-cyan-bright">
              事業・プロダクト
            </div>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li>
                <Link to="/business" className="hover:text-white transition-colors">
                  事業・サービス一覧
                </Link>
              </li>
              <li>
                <Link to="/products/1minute-solar" className="hover:text-white transition-colors">
                  1minute solar（導入前の判断支援）
                </Link>
              </li>
              <li>
                <Link to="/products/spaq-core" className="hover:text-white transition-colors">
                  SPAQ CORE（導入後の現場協調制御）
                </Link>
              </li>
              <li>
                <Link to="/technology" className="hover:text-white transition-colors">
                  技術と開発（電力インテリジェンス）
                </Link>
              </li>
              <li>
                <Link to="/partners" className="hover:text-white transition-colors">
                  協業・パートナー
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4 space-y-3">
            <div className="text-xs font-bold tracking-wider uppercase text-spaq-cyan-bright">
              企業情報・サポート
            </div>
            <ul className="space-y-2.5 text-sm text-slate-300">
              <li>
                <Link to="/cases" className="hover:text-white transition-colors">
                  実績・事例・試算モデル
                </Link>
              </li>
              <li>
                <Link to="/company" className="hover:text-white transition-colors">
                  会社情報・代表メッセージ・沿革
                </Link>
              </li>
              <li>
                <Link to="/news" className="hover:text-white transition-colors">
                  お知らせ・ニュース
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  お問い合わせ・ご相談窓口
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-white transition-colors">
                  プライバシーポリシー
                </Link>
              </li>
              <li className="pt-1">
                <a
                  href="https://1minute.spaq.ltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1 text-spaq-cyan-bright hover:underline text-xs font-semibold"
                >
                  <span>1minute solar Webシミュレーター</span>
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <div>
            © {new Date().getFullYear()} {COMPANY_INFO.name} ({COMPANY_INFO.nameEn}) All Rights Reserved.
          </div>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="hover:text-white transition-colors">
              個人情報保護方針
            </Link>
            <Link to="/company" className="hover:text-white transition-colors">
              会社概要
            </Link>
            <Link to="/contact" className="hover:text-white transition-colors">
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
